
<div class="body" id="success">
    <div *ngIf="data.success && !data.warning" id="green-circle">
        <app-icon symbol="Check"></app-icon>
    </div>

    <div *ngIf="!data.success && !data.warning" id="red-circle">
        <mat-icon class="white">close</mat-icon>
    </div>

    <div *ngIf="data.warning && !data.success">
        <mat-icon class="yellow-warning">warning</mat-icon>
    </div>

    <h3 i18n *ngIf="data.success && !data.warning" class="success">{{data.result}}</h3>

    <p *ngIf="data.subHeader" i18n [innerHTML]="data.subHeader"></p>

    <p i18n [innerHTML]="data.message"></p>
    <p *ngIf="data.link"><a (click)="close()" [routerLink]="['/restricted-product', data.accountId]">{{data.linkTitle}} <mat-icon>launch</mat-icon></a></p>

    <button *ngIf="data.authDownload" mat-flat-button color="primary" (click)="downloadAuthorization(data.authorization)">Download PDF</button>

    <button *ngIf="data.buttonTxt" mat-flat-button color="primary"
    (click)="close()">
        {{data.buttonTxt}}
    </button>
</div>
